import { createSelector } from "reselect";

import type { LegCards } from "./get-leg-cards";

import { getFilteredLegCardIdsByAmenities } from "./get-filtered-leg-card-ids-by-amenities";
import { getFilteredLegCardIdsByCombinedFilters } from "./get-filtered-leg-card-ids-by-combined-filters";
import { getFilteredLegCarIdsByMaxPrice } from "./get-filtered-leg-card-ids-by-max-price";
import { getFilteredLegCardIdsByVehicleLayoutType } from "./get-filtered-leg-card-ids-by-vehicle-layout-type";
import { getLegCards } from "./get-leg-cards";

export const getFilteredLegCardsNoExcludedSources = createSelector(
  [
    getLegCards,
    getFilteredLegCardIdsByVehicleLayoutType,
    getFilteredLegCardIdsByAmenities,
    getFilteredLegCardIdsByCombinedFilters,
    getFilteredLegCarIdsByMaxPrice
  ],
  (
    leg_cards,
    leg_card_ids_with_vehicle_layout_type,
    leg_card_ids_with_amenities,
    leg_card_ids_with_combined_filters,
    leg_card_ids_with_max_price
  ) => {
    const leg_card_ids = Object.keys(leg_cards);

    return leg_card_ids
      .filter(id => {
        // Remove leg cards with wrong Vehicle layout type
        if (!leg_card_ids_with_vehicle_layout_type.includes(id)) {
          return false;
        }
        // Remove leg cards with wrong Amenities type
        if (!leg_card_ids_with_amenities.includes(id)) {
          return false;
        }

        if (!leg_card_ids_with_max_price.includes(id)) {
          return false;
        }
        // Remove leg cards according selected filters
        if (!leg_card_ids_with_combined_filters.includes(id)) {
          return false;
        }

        return true;
      })
      .reduce<LegCards>((filtered_leg_cards, id) => {
        filtered_leg_cards[id] = [...(leg_cards[id] ?? [])];
        return filtered_leg_cards;
      }, {});
  }
);
